<template>
  <div
    v-uni-aria-labelledby="'alert-message'"
    class="error-message"
    :class="alertType"
    role="alertdialog"
    tabindex="0"
  >
    <div class="error-message__icon">
      <svgicon
        class="error-icon"
        :name="type.toLowerCase() === 'warning' ? 'Alerts/Warning' : 'Alerts/Info'"
      />
    </div>
    <div
      v-if="message"
      v-edit="'Message'"
      v-uni-id="'alert-message'"
      class="error-message__wrapper"
    >
      <p v-text="message" />
      <a
        v-if="linkUrl && linkText"
        v-edit="'LinkText'"
        :href="linkUrl"
        v-text="linkText"
      />
    </div>
    <ica-button
      v-uni-aria-labelledby="'close-alert'"
      :size="40"
      type="transparent"
      :has-icon="true"
      role="button"
      tabindex="0"
      @click.native="closeAlert(id)"
    >
      <template #content>
        <span
          v-uni-id="'close-alert'"
          class="close-text"
        >Stäng</span>
        <svgicon
          class="error-icon"
          name="Controls/Close"
        />
      </template>
    </ica-button>
  </div>
</template>

<script>
import svgIcon from "vue-svgicon"
import IcaButton from './Button'
import "./icons/Alerts/Warning"
import "./icons/Alerts/Info"
import "./icons/Controls/Close"
import { createUniqIdsMixin } from 'vue-uniq-ids'

  export default {
    name: "IcaAlertBanner",
    components: {
       svgicon: svgIcon,
       IcaButton
    },
    mixins: [createUniqIdsMixin()],
    props: {
      id: {
        type: String,
        default: ""
      },
      type: {
        type: String,
        default: "Warning"
      },
      message: {
        type: String,
        default: ""
      },
      linkText: {
        type: String,
        default: ""
      },
      linkUrl: {
        type: String,
        default: ""
      }
    },
    computed: {
      alertType () {
        return this.type.toLowerCase() === "warning" ? 'warning' : 'information'
      }
    },
    methods: {
      closeAlert (id) {
        this.$emit('close-alert', id)
      }
    }
  }
</script>

<style lang="scss">
  .error-message {
      $this: &;
      background: $color-yellow-special;
      width: 100%;
      max-width: 77rem;
      margin: 0 auto;
      display: flex;
      align-items: center;
      box-shadow:  $box-shadow-primary;
      border-bottom: 0.0625rem solid $color-grey-special;
      &:last-of-type  {
        border-radius: 0 0 0.25rem 0.25rem;
        border-bottom: 0;
        .error-message__icon {
          border-radius: 0 0 0 0.25rem;
        }
      }

      &__icon {
        width: 2rem;
        min-width: 2rem;
        background: $color-yellow-dark;
        align-self: stretch;
        justify-content: center;
        display: inline-flex;
        .error-icon {
          margin-top: 0.625rem;
          width: 1.5rem;
          height: 1.5rem;
          fill: $color-white;
        }
      }

      &__wrapper {
        display: inline-flex;
        padding: 0.75rem 0 0.75rem 1rem;
        flex-wrap: wrap;

        @include media-breakpoint-up(md) {
          padding-left: 1.5rem;
        }
        a {
          text-decoration: none;
          @include font(text, 2, bold);
          color: $color-secondary-cta-text;
          &:hover {
            color: $color-pink-light;
          }
        }
      }

      &.information {
        background: $color-purple-special;
       & .error-message__icon {
          background: $color-purple-dark;
        }
      }

      p {
        @include font(text, 2, normal);
        margin: 0 0.3125rem 0 0;
      }

      .button.button--40.button--text-icon {
        margin-left: auto;
        padding-right: 1rem;
        margin-bottom: auto;
        padding-top: 0.75rem;
        min-width: 3.75rem;
        @include media-breakpoint-up(md) {
          min-width: 6.375rem;
        }

        .close-text {
          display: none;
          @include font(text, 2, bold);
          @include media-breakpoint-up(md) {
            display: inline-block;
          }
        }
        .error-icon {
          margin-right: 0;
        }
      }
    }

</style>
